import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  HStack,
  Toaster,
} from '@shared/ui';

export function ToastShowcase() {
  const { t } = useTranslation();

  const handleDefaultToast = () => {
    toast(t('uiLibrary.feedback.toast.messages.default'));
  };

  const handleSuccessToast = () => {
    toast.success(t('uiLibrary.feedback.toast.messages.success'));
  };

  const handleErrorToast = () => {
    toast.error(t('uiLibrary.feedback.toast.messages.error'));
  };

  const handleLoadingToast = () => {
    const id = toast.loading(t('uiLibrary.feedback.toast.messages.loading'));
    window.setTimeout(() => toast.dismiss(id), 1400);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.feedback.toast.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.feedback.toast.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <HStack gap="sm" className="flex-wrap">
          <Button variant="outline" onClick={handleDefaultToast}>
            {t('uiLibrary.feedback.toast.buttons.default')}
          </Button>
          <Button onClick={handleSuccessToast}>
            {t('uiLibrary.feedback.toast.buttons.success')}
          </Button>
          <Button variant="destructive" onClick={handleErrorToast}>
            {t('uiLibrary.feedback.toast.buttons.error')}
          </Button>
          <Button variant="secondary" onClick={handleLoadingToast}>
            {t('uiLibrary.feedback.toast.buttons.loading')}
          </Button>
        </HStack>
      </CardContent>
      <Toaster />
    </Card>
  );
}
